module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/MultipleAlbums-6e01e9c90ef760c5a3108e0c37a51d99.jpg";